import React from 'react';

import { cn } from 'twyne-new.ui';

import { useProps, useClassName } from 'components/pure/hooks';

import './index.scss'

const propTypes = {}
const imutableProps = {}
const mutableProps = {}

const classNames = {
  default: 'rules__groupItem',
}

export default function RuleGroupItemWrapper({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <div {...useProps(props, imutableProps)} className={cn(className, 'w-full')}>
    {children}
  </div>
}

RuleGroupItemWrapper.propTypes = propTypes
RuleGroupItemWrapper.defaultProps = mutableProps
